import { AuthGuard } from './core/auth.guard';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReadMeComponent } from './read-me/read-me.component';
import { ApplePayComponent } from './apple-pay/apple-pay.component';
import { MasterLayoutComponent } from './authentication/master-layout/master-layout.component';

export const routes: Routes = [
  { path: '', redirectTo: 'transactions', pathMatch: 'full' },
  {
    path: 'admin',
    loadChildren: () =>
      import('../app/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'authentication',
    loadChildren: () =>
      import('../app/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  /** Personall Added Modulees */
  {
    path: 'accounts',
    loadChildren: () =>
      import('../app/accounts/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'messages',
    loadChildren: () =>
      import('../app/messages/messages.module').then((m) => m.MessagesModule),
  },
  {
    path: 'organization',
    loadChildren: () =>
      import('../app/organization/organization.module').then(
        (m) => m.OrganizationModule
      ),
  },
  {
    path: 'membership-card',
    component: MasterLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './membership-card/pages/virtual-card-page/virtual-card-page.component'
          ).then((m) => m.VirtualCardPageComponent),
        data: { title: 'duesPlus :: Digital Membership Card' },
      },
    ],
  },
  {
    path: 'categories',
    loadChildren: () =>
      import('../app/categories/category.module').then((m) => m.CategoryModule),
  },
  {
    path: 'payments',
    loadChildren: () =>
      import('../app/payments/payment.module').then((m) => m.PaymentModule),
  },
  {
    path: 'sale',
    loadChildren: () =>
      import('../app/sale-campaign/sale-campaign.module').then(
        (m) => m.SaleCampaignModule
      ),
  },
  {
    path: 'members',
    loadChildren: () =>
      import('../app/members/members.module').then((m) => m.MembersModule),
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('../app/pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: 'form',
    loadChildren: () =>
      import('../app/form/form.module').then((m) => m.FormModule),
  },
  {
    path: 'invoice',
    loadChildren: () =>
      import('../app/invoice/invoice.module').then((m) => m.InvoiceModule),
  },
  {
    path: 'sale',
    loadChildren: () =>
      import('../app/sale-campaign/sale-campaign.module').then(
        (m) => m.SaleCampaignModule
      ),
  },
  {
    path: 'transactions',
    loadChildren: () =>
      import('../app/transactions/transaction.module').then(
        (m) => m.TransactionModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('../app/reports/reports.module').then((m) => m.ReportsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'members',
    loadChildren: () =>
      import('../app/members/members.module').then((m) => m.MembersModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'meetings',
    loadChildren: () =>
      import('../app/meetings/meetings.module').then((m) => m.MeetingsModule),
  },
  {
    path: 'sub-groups',
    loadChildren: () =>
      import('../app/sub-groups/sub-groups.module').then((m) => m.SubGroupsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'utilities',
    loadChildren: () =>
      import('../app/utilities/utilities.module').then((m) => m.UtilitiesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'naa-budget',
    loadChildren: () =>
      import('../app/naa-budget-tools/naa-budget-tools.module').then(
        (m) => m.NaaBudgetToolsModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'read-me',
    component: ReadMeComponent,
  },
  // {
  //   path: '.well-known/apple-developer-merchantid-domain-association',
  //   component: ApplePayComponent,
  // },
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(
  routes,
  { useHash: false /*, enableTracing: true */ }
);
